import * as React from 'react';

function SvgLocationStroke(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16 4.346A10.703 10.703 0 0125.654 14H29v2h-3.346A10.703 10.703 0 0116 25.654V29h-2v-3.346A10.703 10.703 0 014.346 16H1v-2h3.346A10.703 10.703 0 0114 4.346V1h2v3.346zM15 24.3a9.3 9.3 0 100-18.6 9.3 9.3 0 000 18.6zm1-9.3a1 1 0 11-2 0 1 1 0 012 0zm2 0a3 3 0 11-6 0 3 3 0 016 0z"
        fill="#414B56"
      />
    </svg>
  );
}

export default SvgLocationStroke;
